import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Button } from "@mui/material";
import client from "../../Common/Client/Client";
import TextField from "@mui/material/TextField";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const PdfGenerate = () => {
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [phone, setPhone] = useState("");
  const [isPending, setIsPending] = useState(false);
  const [packageDetails, setPackageDetails] = useState([]);
  const [selectPackage, setSelectPackage] = useState();

  const PdfGenerate = async () => {
    setIsPending(true);
    const dateObj = new Date(selectedDate);
    const day = String(dateObj.getUTCDate()).padStart(2, "0");
    const month = String(dateObj.getUTCMonth() + 1).padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const formatDate = `${day}/${month}/${year}`;

    try {
      const response = await client.get(
        `/admin-pdf/pdfGenerate?date=${formatDate}&phone=${phone}&packageId=${selectPackage}`,
        {
          withCredentials: true,
        },
      );
      console.log(response);
      if (response.status === 200) {
        const byteCharacters = atob(response.data);
        const byteNumbers = Array.from(byteCharacters).map((c) =>
          c.charCodeAt(0),
        );
        const byteArray = new Uint8Array(byteNumbers);
        const pdfBlob = new Blob([byteArray], {
          type: "application/pdf",  
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(pdfBlob);
        link.download = "Bus-ticket.pdf";
        link.click();
        setPhone("")
        setSelectedDate(dayjs())
      }
    } catch (error) {
      console.log(error);
    }
  };

  const packageDetail = async () => {
    try {
      const response = await client.get("/admin-pdf/package-details", {
        withCredentials: true,
      });
      console.log(response);
      if (response.status === 200) {
        setPackageDetails(response.data);
        setSelectPackage(response.data[0]._id);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    packageDetail();
  }, []);
  return (
    <>
      <main id="main" className="main">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">Pdf Generate</li>
            </ol>
          </nav>
        </div>
        <section
          className="section dashboard"
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "70px",
          }}
        >
          <div className="card" style={{ width: "100%" }}>
            <div className="card-body" style={{ padding: "20px" }}>
              <h5
                className="card-title"
                style={{ textAlign: "center", marginBottom: "20px" }}
              >
                Pdf Generate
              </h5>
              <div className="row align-items-center">
                <div className="col-md-4">
                  <div>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Select Travel Date"
                        value={selectedDate}
                        format="DD/MM/YYYY"
                        onChange={(newValue) => {
                          setSelectedDate(newValue);
                        }}
                        slotProps={{ textField: { fullWidth: true } }}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                <div className="col-md-4">
                  <TextField
                    id="outlined-basic"
                    label="Phone Number"
                    variant="outlined"
                    name="phone"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>

                <div className="col-md-4">
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Package
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="package"
                      name="package"
                      onChange={(e) => setSelectPackage(e.target.value)}
                    >
                      {packageDetails &&
                        packageDetails?.map((each) => {
                          return <MenuItem value={each._id}>{each.packageName}</MenuItem>;
                        })}
                    </Select>
                  </FormControl>
                </div>

                <div className="col-md-4">
                  <div>
                    <Button
                      variant="contained"
                      className=""
                      onClick={PdfGenerate}
                      // disabled={open}
                      style={{
                        backgroundColor: "#e89e25 ",
                        marginTop: "10px",
                      }}
                    >
                      Generate PDF
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default PdfGenerate;
